import script from "./DDModelViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./DDModelViewer.vue?vue&type=script&setup=true&lang=js"

import "./DDModelViewer.vue?vue&type=style&index=0&id=290aada4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-290aada4"]])

export default __exports__